import { render } from "./luckDraw.vue?vue&type=template&id=975c53ae&scoped=true"
import script from "./luckDraw.vue?vue&type=script&lang=js"
export * from "./luckDraw.vue?vue&type=script&lang=js"

import "./luckDraw.vue?vue&type=style&index=0&id=975c53ae&scoped=true&lang=css"

import exportComponent from "E:\\waibao\\isa-community-toupin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-975c53ae"]])

export default __exports__